import './reviews.css';
import Stars from '../../stars rate/Stars';
import { useFetchData } from '../../../hooks/useFetchData';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { formatArabicDate } from '../../../utils/dateformat';

function ReviewsPage() {
  const {auth} = useAuthContext();
 

  const {data: comments} = useFetchData("mandoub/reviews?id="+auth?.user._id,[auth])
  
  return (
    <div className=" reviews">
      <div className="df-c ai-c !w-10/12">

      <div className="df-c section-card comments-upper !w-100 !gap-6">
      <div className="title">التقييمات</div>
      <div className="df w-full jc-c  ai-stretch">
      <div className="df-c">
          <div className="bold-1">إجمالي التقييمات</div>
          <div>
            <div className="df">
              <div className="bold-1 text-4xl">{comments?.stats.totalComments}</div> 
             
            </div>
          </div>
        </div>
        <div className="df-c bordered">
          <div className="bold-1">متوسط التقييمات</div>
          <div>
            <div className="df">
              <div className="bold-1 text-4xl">{comments?.stats.averageRating}</div> 
              <Stars number={Math.floor(comments?.stats.averageRating)} />
            </div>
          </div>
        </div>
        {comments && comments?.stats &&<div className="df-c">
          <div className="bold-1">إجمالي التقييمات</div>
          <div className="rev-cont">
            <div className="df avg-star-nbr ai-fe">
              <span className="nbr-indic">5</span> 
              <div className="review-line-container">
                <div className="line" style={{ width: `${comments?.stats.ratingPercentages[5]}%` }}></div>
              </div>
             
            </div>
            <div className="df avg-star-nbr ai-fe">
              <span className="nbr-indic">4</span> 
              <div className="review-line-container" style={{ background: 'var(--cyan-light)' }}>
                <div className="line" style={{ width: `${comments?.stats.ratingPercentages[4]}%`, background: 'var(--cyan)' }}></div>
              </div>
              
            </div>
            <div className="df avg-star-nbr ai-fe">
              <span className="nbr-indic">3</span> 
              <div className="review-line-container" style={{ background: 'var(--purple-light)' }}>
                <div className="line" style={{ width: `${comments?.stats.ratingPercentages[3]}%`, background: 'var(--purple)' }}></div>
              </div>
             
            </div>
            <div className="df avg-star-nbr ai-fe">
              <span className="nbr-indic">2</span> 
              <div className="review-line-container" style={{ background: 'var(--shipped-light)' }}>
                <div className="line" style={{ width: `${comments?.stats.ratingPercentages[2]}%`, background: 'var(--shipped)' }}></div>
              </div>
             
            </div>
            <div className="df avg-star-nbr ai-fe">
              <span className="nbr-indic">1</span> 
              <div className="review-line-container">
                <div className="line" style={{ width: `${comments?.stats.ratingPercentages[1]}%` }}></div>
              </div>
             
            </div>
          </div>
        </div>}
      </div>
      </div>
      
      
      {comments && comments?.reviews &&<div className="comments !w-100 section-card">
        {comments?.reviews.map((review, index) => (
          <div key={index} className="df comment ai-fs gap-8">
            <div className="df comment-user-img ai-stretch">
              <img
                src={(review?.img? review?.img : "/img/default.png")}
                alt="user"
              />
              <div className="df-c jc-sb flex-1">
                <div className="bold-1 text-lg">{review.name} {review.surname}</div>
                <div>
                  <div className="text">{review.orders}</div>
                </div>
              </div>
            </div>
            <div className="comment-content df-c">
              <div className="text df text-xs">
                <Stars number={review.rating} /> {formatArabicDate(review.createdAt)}
              </div>
              <div className="text">{review.comment}</div>
              
            </div>
          </div>
        ))}
      </div>}
      </div>
    </div>
  );
}

export default ReviewsPage;
